const SCIENCE_ICONS = {
  building: () => (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.0046 13.0432H2.99882C1.71936 13.0432 1.17102 11.6495 2.17631 10.9869L15.6792 2.14489C15.9285 1.99823 16.2125 1.9209 16.5017 1.9209C16.7909 1.9209 17.0749 1.99823 17.3242 2.14489L30.8271 10.9869C31.8324 11.6495 31.284 13.0432 30.0046 13.0432Z"
        stroke="#8E9D9C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.2078 25.6089H2.79081C2.1599 25.6089 1.64844 26.1204 1.64844 26.7513V30.1784C1.64844 30.8092 2.1599 31.3208 2.79081 31.3208H30.2078C30.8387 31.3208 31.3502 30.8092 31.3502 30.1784V26.7513C31.3502 26.1204 30.8387 25.6089 30.2078 25.6089Z"
        stroke="#8E9D9C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.07812 13.0427V25.6089"
        stroke="#8E9D9C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6875 13.0427V25.6089"
        stroke="#8E9D9C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3086 13.0427V25.6089"
        stroke="#8E9D9C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9258 13.0427V25.6089"
        stroke="#8E9D9C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dna: () => (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4307_7516)">
        <path
          d="M24.9508 25.6615V29.2709C24.9508 29.5494 24.8402 29.8164 24.6433 30.0134C24.4464 30.2103 24.1793 30.3209 23.9008 30.3209C23.6224 30.3209 23.3553 30.2103 23.1584 30.0134C22.9615 29.8164 22.8508 29.5494 22.8508 29.2709V25.6615C22.856 24.1003 22.4237 22.5689 21.603 21.2408C20.7822 19.9127 19.6059 18.8411 18.2072 18.1475L11.8547 14.9725C10.1065 14.1055 8.63617 12.766 7.61035 11.1059C6.58454 9.4459 6.04429 7.53168 6.05084 5.58027V1.9709C6.05084 1.69242 6.16146 1.42535 6.35838 1.22844C6.55529 1.03152 6.82236 0.920898 7.10084 0.920898C7.37932 0.920898 7.64639 1.03152 7.8433 1.22844C8.04022 1.42535 8.15084 1.69242 8.15084 1.9709V5.58027C8.14569 7.14148 8.57799 8.67291 9.39872 10.001C10.2195 11.3291 11.3958 12.4007 12.7945 13.0943L19.147 16.2693C20.8952 17.1363 22.3655 18.4758 23.3913 20.1359C24.4171 21.7959 24.9574 23.7101 24.9508 25.6615ZM19.7008 25.0709H8.17315C8.22366 24.3556 8.36615 23.6498 8.59709 22.9709H18.1403C18.4188 22.9709 18.6858 22.8603 18.8827 22.6634C19.0797 22.4664 19.1903 22.1994 19.1903 21.9209C19.1903 21.6424 19.0797 21.3753 18.8827 21.1784C18.6858 20.9815 18.4188 20.8709 18.1403 20.8709H9.65497C10.1819 20.1092 10.8317 19.4404 11.5778 18.8916C11.6891 18.81 11.7833 18.7073 11.8549 18.5893C11.9266 18.4713 11.9743 18.3403 11.9953 18.2039C12.0163 18.0674 12.0103 17.9282 11.9775 17.7941C11.9447 17.66 11.8858 17.5336 11.8042 17.4223C11.7226 17.311 11.6198 17.2168 11.5018 17.1451C11.3838 17.0735 11.2528 17.0258 11.1164 17.0048C10.98 16.9838 10.8407 16.9898 10.7066 17.0226C10.5725 17.0554 10.4462 17.1143 10.3348 17.1959C9.00848 18.1737 7.92995 19.4489 7.18593 20.9192C6.44191 22.3894 6.05313 24.0137 6.05084 25.6615V29.2709C6.05084 29.5494 6.16146 29.8164 6.35838 30.0134C6.55529 30.2103 6.82236 30.3209 7.10084 30.3209C7.37932 30.3209 7.64639 30.2103 7.8433 30.0134C8.04022 29.8164 8.15084 29.5494 8.15084 29.2709V27.1709H19.7008C19.9793 27.1709 20.2464 27.0603 20.4433 26.8634C20.6402 26.6664 20.7508 26.3994 20.7508 26.1209C20.7508 25.8424 20.6402 25.5753 20.4433 25.3784C20.2464 25.1815 19.9793 25.0709 19.7008 25.0709ZM23.9008 0.920898C23.6224 0.920898 23.3553 1.03152 23.1584 1.22844C22.9615 1.42535 22.8508 1.69242 22.8508 1.9709V4.0709H11.3008C11.0224 4.0709 10.7553 4.18152 10.5584 4.37844C10.3615 4.57535 10.2508 4.84242 10.2508 5.1209C10.2508 5.39938 10.3615 5.66645 10.5584 5.86336C10.7553 6.06027 11.0224 6.1709 11.3008 6.1709H22.8285C22.778 6.8862 22.6355 7.59202 22.4046 8.2709H12.8614C12.5829 8.2709 12.3159 8.38152 12.1189 8.57844C11.922 8.77535 11.8114 9.04242 11.8114 9.3209C11.8114 9.59938 11.922 9.86645 12.1189 10.0634C12.3159 10.2603 12.5829 10.3709 12.8614 10.3709H21.3467C20.8198 11.1326 20.17 11.8014 19.4239 12.3501C19.1994 12.515 19.0495 12.7622 19.0073 13.0375C18.9651 13.3129 19.034 13.5937 19.1988 13.8182C19.3636 14.0427 19.6109 14.1926 19.8862 14.2348C20.1615 14.277 20.4423 14.2081 20.6668 14.0433C21.9928 13.0658 23.0712 11.791 23.8152 10.3212C24.5592 8.8514 24.9481 7.22763 24.9508 5.58027V1.9709C24.9508 1.69242 24.8402 1.42535 24.6433 1.22844C24.4464 1.03152 24.1793 0.920898 23.9008 0.920898Z"
          fill="#8E9D9C"
        />
      </g>
      <defs>
        <clipPath id="clip0_4307_7516">
          <rect width="30.9001" height="29.4" fill="white" transform="translate(0.0507812 0.920898)" />
        </clipPath>
      </defs>
    </svg>
  ),
  microscope: () => (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4307_11110)">
        <path
          d="M29.0678 28.0594H26.2324C32.3201 20.6616 28.1165 9.44782 18.666 7.87463C18.3655 7.82462 18.0634 7.78565 17.7601 7.75782V3.18244C17.7601 1.93342 16.7476 0.920898 15.4986 0.920898H8.71394C7.46493 0.920898 6.4524 1.93342 6.4524 3.18244V17.8824C6.4524 19.1314 7.46493 20.144 8.71394 20.144H15.4986C16.7476 20.144 17.7601 19.1314 17.7601 17.8824V10.0321C25.5455 10.9047 29.4668 19.878 24.8184 26.1841C24.3031 26.8832 23.7005 27.5134 23.0252 28.0594H1.92932C1.05885 28.0594 0.514807 29.0017 0.950077 29.7556C1.15206 30.1054 1.52537 30.3209 1.92932 30.3209H29.0678C29.9382 30.3209 30.4823 29.3785 30.047 28.6247C29.845 28.2749 29.4718 28.0594 29.0678 28.0594ZM15.4986 17.8824H8.71394V3.18244H15.4986V17.8824ZM7.58317 24.667C6.7127 24.667 6.16865 23.7247 6.60392 22.9708C6.80591 22.621 7.1792 22.4055 7.58317 22.4055H16.6293C17.4998 22.4055 18.0438 23.3478 17.6086 24.1017C17.4066 24.4515 17.0333 24.667 16.6293 24.667H7.58317Z"
          fill="#8E9D9C"
        />
      </g>
      <defs>
        <clipPath id="clip0_4307_11110">
          <rect width="29.4034" height="29.4" fill="white" transform="translate(0.796875 0.920898)" />
        </clipPath>
      </defs>
    </svg>
  ),
  sixtyPlus: () => (
    <svg width="65" height="31" viewBox="0 0 65 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M64.7247 14.3502V16.5107H57.6924V23.9666H55.2354V16.5107H48.2031V14.3502H55.2354V6.89429H57.6924V14.3502H64.7247Z"
        fill="#8E9D9C"
      />
      <path
        d="M34.4652 30.3209C27.8565 30.3209 23.832 25.2797 23.832 15.6632C23.832 6.04683 27.8565 0.920898 34.4228 0.920898C41.0314 0.920898 45.0136 6.04683 45.0136 15.6632C45.0136 25.2797 41.0314 30.3209 34.4652 30.3209ZM34.4228 27.9909C39.464 27.9909 42.4294 23.7969 42.4294 15.6632C42.4294 7.52953 39.464 3.2085 34.4228 3.2085C29.424 3.2085 26.4585 7.52953 26.4585 15.6632C26.4585 23.7969 29.424 27.9909 34.4228 27.9909Z"
        fill="#8E9D9C"
      />
      <path
        d="M10.7795 11.9778C16.2019 11.9778 20.057 15.7057 20.057 21.1282C20.057 26.4659 16.2019 30.321 10.5677 30.321C4.25556 30.321 0.273438 25.6187 0.273438 15.7904C0.273438 5.91986 4.29793 0.963379 10.7371 0.963379C15.7783 0.963379 19.4639 3.92879 19.4639 8.41928H16.8798C16.8798 4.98787 14.1262 3.25098 10.7795 3.25098C5.823 3.25098 2.73049 7.40256 2.73049 15.7481V16.8072C4.17084 13.9265 7.26334 11.9778 10.7795 11.9778ZM10.5677 27.991C14.6345 27.991 17.4728 25.2374 17.4728 21.0858C17.4728 17.0613 14.8463 14.3077 10.7795 14.3077C6.45844 14.3077 2.05269 17.6121 3.78957 23.0769H3.74721C4.97574 26.4659 7.3057 27.991 10.5677 27.991Z"
        fill="#8E9D9C"
      />
    </svg>
  ),
}

export type HomepageScienceIconName = keyof typeof SCIENCE_ICONS

type HomepageScienceIconProps = {
  iconName: HomepageScienceIconName
}

export const HomepageScienceIcon = ({ iconName }: HomepageScienceIconProps) => SCIENCE_ICONS[iconName]?.()
